import Spine from './spine'
import Stage from './Stage'
import SpriteAnimation from './spriteAnimation'
import ImgFromTexture from './imgFromTexture'
import BitmapText from './bitmapText'
import BoneMerge from './boneMerge'
import BoneMergeContainer from './boneMergeRenderer'
import Watermark from './watermark'
import AutoSizeText from './autoSizeText'

/**
 * All the react-components
 *
 * This is a abstraction
 */
module.exports = {
  BitmapText,
  ImgFromTexture,
  Spine,
  SpriteAnimation,
  Stage,
  BoneMerge,
  BoneMergeContainer,
  Watermark,
  AutoSizeText
}
